import { useState } from 'react';
import { observer } from 'mobx-react-lite';
import { IRecruitSFilter } from 'src/@types/SearchFilterTypes';

import { Page } from '../../../components/Page';

import RecruitGrid from './RecruitGrid';
import SearchForm from './SearchForm';
/** * ## Recruit 설명 * */
export const Recruit = observer(() => {
  // 검색 조건
  const [searchData, setSearchData] = useState<Partial<IRecruitSFilter>>({});
  // 목록 검색
  const onSearch = (data: IRecruitSFilter) => {
    setSearchData(data);
  };
  return (
    <Page>
      <SearchForm onSearch={onSearch} />
      <RecruitGrid searchData={searchData} />
    </Page>
  );
});
export default Recruit;
